import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';

import { requestDownloadLeaderboardExcel, requestViewLeaderboard } from './leaderboard.actions';
import { getDownloadLeaderboardExcelRequest, getViewLeaderboardRequest } from './leaderboard.endpoints';

import { addSystemNotice, addSpinner, removeSpinner } from '../../slices/system/system.slice';
import { setLeaderboard } from '../../slices/programme/accountability/accountability.slice';

import { ERROR, SUCCESS } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';

export function* performViewLeaderboardRequest({ payload }) {
  const { externalReference, onSuccess } = payload;

  try {
    yield put(addSpinner('Retrieving Leaderboard'));

    const [endpoint, options] = getViewLeaderboardRequest(externalReference);

    const { data } = yield call(axios, endpoint, options);

    yield put(addSystemNotice({ type: SUCCESS, message: data.message }));

    if (onSuccess) {
      yield call(onSuccess);
    }

    delete data.message;
    yield put(setLeaderboard(data));

    yield put(removeSpinner('Retrieving Leaderboard'));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(removeSpinner('Retrieving Leaderboard'));
    yield put(setLeaderboard(undefined));
    yield put(addSystemNotice({ type: ERROR, message }));
  }
}

export function* watchForViewLeaderboardRequest() {
  yield takeLatest(requestViewLeaderboard.type, performViewLeaderboardRequest);
}

export function* performDownloadLeaderboardExcelRequest({ payload }) {
  const { input, onSuccess } = payload;

  try {
    yield put(addSpinner('Downloading Leaderboard Excel'));

    const [endpoint, options] = getDownloadLeaderboardExcelRequest(input);

    const { data } = yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess, data.base64EncodedString);
    }

    yield put(removeSpinner('Downloading Leaderboard Excel'));
    yield put(addSystemNotice({ type: SUCCESS, message: data.message }));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(removeSpinner('Downloading Leaderboard Excel'));
    yield put(addSystemNotice({ type: ERROR, message }));
  }
}

export function* watchForDownloadLeaderboardExcelRequest() {
  yield takeLatest(requestDownloadLeaderboardExcel.type, performDownloadLeaderboardExcelRequest);
}

export default function* leaderboardSaga() {
  yield all([watchForViewLeaderboardRequest(), watchForDownloadLeaderboardExcelRequest()]);
}
